import { Spinner } from '@gmg/gmg-react-components';
import { FC } from 'react';
import { useGetLicenseSystemDetails } from 'src/graphql/useGetLicenseSystemDetails';
import LicenseSystemInfoModal from './LicenseSystemInfoModal';

interface LicenseSystemInfoModalContainerProps {
    licenseSystemId: string;
    orgId: string;
    onClose?: () => void;
}

const LicenseSystemInfoModalContainer: FC<LicenseSystemInfoModalContainerProps> = (props) => {

    const { data: licenseSystemDetails } = useGetLicenseSystemDetails(props.licenseSystemId, props.orgId);

    if (!licenseSystemDetails) {
        return <Spinner />;
    }

    return (
        <LicenseSystemInfoModal
            licenseSystemDetails={{
                appServiceVersion: licenseSystemDetails.appServiceVersion,
                updateNumber: licenseSystemDetails.updateNumber,
                installedUpdateNumber: licenseSystemDetails.installedUpdateNumber,
                lastSeenDate: licenseSystemDetails.lastSeenDate,
                addedBy: licenseSystemDetails.addedBy,
                colorProofGoUsers: licenseSystemDetails.colorProofGoUsers,
                colorCardUsers: licenseSystemDetails.colorCardUsers,
            }}
            onClose={props.onClose!}
        />
    );
};

export default LicenseSystemInfoModalContainer;